import MRichTextEditor from './index.vue';

MRichTextEditor.install = app => {
  app.component(MRichTextEditor.name, MRichTextEditor);
};

export default MRichTextEditor;
